import React from 'react';
import { Card, Col, ListGroup, Row } from 'reactstrap';

import ImageExpand from '../ImageExpand';
import MCAnswer from './MCAnswer';

const POSSIBLE_POSITIONS = [1, 2, 3, 4];
const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

export default class MCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      correct: false,
      selectedAnwer: null,
    };
    this.checkAnswered = this.checkAnswered.bind(this);
  }

  selectAnswer = (selectedAnwerId) => {
    this.setState({ selectedAnwer: selectedAnwerId });
  };

  checkAnswered(e) {
    return this.props.getClickedState();
  }

  doAnswer = (correct, answerId = null) => {
    this.setState({ correct }, () => {
      this.props.updateIsCorrect(correct);
    });

    this.props.setClicked(answerId);
  };

  getOrderedAnswers = (answers) => {
    if (!answers || answers.length === 0) {
      return [];
    }
    const currentPossitions = answers.map((a) => a.order);
    let remainingPositions = POSSIBLE_POSITIONS.filter(
      (p) => !currentPossitions.includes(p),
    );
    remainingPositions = shuffleArray(remainingPositions);
    return answers
      .map((a) => {
        if (a.order === 0) {
          a.order = remainingPositions.pop();
        }
        return a;
      })
      .sort((a, b) => a.order - b.order);
  };

  removeEmptyAnswers = (answers = []) => {
    if (answers && answers.length > 0) {
      const answersNotEmpty = answers?.filter(
        // check if text is empty or if there is a image to show
        (a) =>
          (a?.text && a.text.replace(/&nbsp;[ ]{0,}/g, '') != '') ||
          a?.imageUrl,
      );
      return answersNotEmpty;
    }

    return [];
  };

  render() {
    const orderedAnswers = this.getOrderedAnswers(
      this.removeEmptyAnswers(this.props.answers),
    );
    const answersHaveImages = orderedAnswers.some((a) => !!a.imageUrl);

    const getAnswerProps = (d, idx) => ({
      counterType: this.props.counterType,
      renderSymbols: this.props.renderSymbols,
      alreadyAnswered: this.props.answered,
      checkAnswered: this.checkAnswered,
      doAnswer: (correct) => this.doAnswer(correct, d.id),
      char: ALPHABET[idx],
      pts: d.points,
      text: d.text,
      key: d.id,
      correct: d.correct,
      markCorrect: !this.state.correct,
      answer: d,
      questionClicked: this.props.clicked,
      setPreviousAnswerClicked: this.props.setPreviousAnswerClicked,
      showPreviousAnswer: this.props.showPreviousAnswer,
      previousAnswerClicked: this.props.previousAnswerClicked,
      selectAnswer: this.selectAnswer,
      selectedAnswer: this.state.selectedAnwer === d.id,
      allowToChangeAnswer: this.props.allowToChangeAnswer,
      fromReview: this.props.fromReview,
    });

    return (
      <Row className="mt-lg-4 mt-sm-0 mcard">
        <Col className="col-12">
          <Card>
            <div className="d-flex flex-md-row flex-column flex-sm-column justify-content-center">
              <ImageExpand imageUrl={this.props.imageUrl} />
              {orderedAnswers ? (
                answersHaveImages ? (
                  <Row
                    className="pl-0 no-gutters multicol-divider"
                    style={{ width: '100%' }}
                  >
                    {orderedAnswers.map((d, idx) => (
                      <Col xs={12} md={6} key={d.id}>
                        <MCAnswer {...getAnswerProps(d, idx)} />
                      </Col>
                    ))}
                  </Row>
                ) : (
                  <ListGroup className="pl-0">
                    {orderedAnswers.map((d, idx) => (
                      <MCAnswer {...getAnswerProps(d, idx)} />
                    ))}
                  </ListGroup>
                )
              ) : (
                <span className="errorMesagge">
                  {' '}
                  Error loading the questions, refresh the page.{' '}
                </span>
              )}
            </div>
          </Card>
        </Col>
      </Row>
    );
  }
}

function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}
